// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1_Gnl","options":"AnswerScale_options__3-GK1","selected":"AnswerScale_selected__SQMoS"};